const PASSWORD_MIN_LENGTH = 8;

const hasMinLength = (password) => password.length >= PASSWORD_MIN_LENGTH;
const hasUppercase = (password) => /[A-Z]/.test(password);
const hasLowercase = (password) => /[a-z]/.test(password);
const hasNumber = (password) => /\d/.test(password);
const doPasswordsMatch = (password, confirmPassword) => password && password === confirmPassword;

/**
 * Checks for a valid password (1 num, 1 lower case, 1 upper case, length > PASSWORD_MIN_LENGTH)
 * @param {string} password - users password
 * @returns {bool} true = valid password
 */
const validatePassword = (pw) => {
    const re = new RegExp(`(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{${PASSWORD_MIN_LENGTH},}`);
    return re.test(pw);
};

/**
 * Check for a valid 6-digit forgot password code
 * @param {string} code - confirmation code
 * @returns {bool} true = 6 digit number
 */
const validConfirmationCode = (code) => /^\d{6}$/.test(code);

/**
 * Validates an email address
 * @param {string} email - The email entered into the text field
 * @return {boolean} Whether or not it is a valid email
 */
const validEmail = (email) => {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(String(email).toLowerCase());
};

export {
    hasMinLength,
    hasUppercase,
    hasLowercase,
    hasNumber,
    doPasswordsMatch,
    validatePassword,
    validConfirmationCode,
    validEmail,
};
